import type { LoaderFunction } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import invariant from "tiny-invariant";
import useLocalStorageState from "use-local-storage-state";
import { getFavoritArticles } from "~/api";
import { CardNew, FullbackScreen, ListItem } from "~/shared";
import { toSafePathSegment } from "~/utils";
import type { ICardProp } from "~/shared/cards/new_card";
import type { IMedia } from "~/types";

export const loader: LoaderFunction = async ({ request, params }) => {
  // const url = new URL(request.url);
  invariant(params.favArticleId, `params.articleId is required`);
  // console.log("loader loader", filterData);

  const { favArticleId } = params;
  const favoriteArticles = await getFavoritArticles(favArticleId);
  // console.log(
  //   "🚀 ~ file: $favArticleId.tsx:18 ~ constloader:LoaderFunction= ~ favoriteArticles:",
  //   favoriteArticles
  // );
  return json(
    {
      //@ts-ignore
      media: favoriteArticles.media,
    },
    {
      headers: {
        // max-age controls the browser cache
        // s-maxage controls a CDN cache
        "Cache-Control": "public, max-age=30, s-maxage=86400",
      },
    }
  );
};

// IMPORTANT ================= refactore this component with search/main/index.tsx

export default function () {
  const data: any = useLoaderData();
  // console.log("🚀 ~ file: $favArticleId.tsx:40 ~ data:", data);

  const [favoriteList, setFavoriteList] = useLocalStorageState<any[]>(
    "favoriteList",
    {
      defaultValue: [],
    }
  );
  // const [favoritleListItem, setItems] = useState(false);

  const isItemFavorite = (id: number) => {
    const itemInFavorite = favoriteList.length
      ? favoriteList.find((item: any) => item.id === id)
      : undefined;
    if (itemInFavorite) {
      return true;
    }
    return false;
  };

  const addToFavorite = (
    { name, firstPicture, id, slug }: IMedia,
    itemInFavorite: any
  ) => {
    if (!itemInFavorite) {
      setFavoriteList([
        // @ts-ignore
        ...favoriteList,
        // @ts-ignore
        {
          name,
          firstPicture,
          id,
          slug,
        },
      ]);
    } else {
      // @ts-ignore
      const newItems = favoriteList.filter((item: any) => item.id !== id);
      if (!newItems) {
        setFavoriteList([]);
      } else {
        setFavoriteList(newItems);
      }
    }
  };

  const getArticleLink = (id: number, name: string, slug?: string) =>
    `${id}/${toSafePathSegment(slug || name)}`;
  if (data && !data.media.length)
    return (
      <FullbackScreen
        // size={size}
        subtitle="Versuche es mit einem anderen Suchbegriff oder verwende weniger Filter. Manchmal hilft auch die Suche in einem anderen Bundesland."
        title="Leider konnten wir kein Medium finden."
      />
    );
  return (
    <div className="media-card-wrapper pt-4">
      <ul className="lg:masonry md:masonry-md">
        {data && data.media.length
          ? data.media.map((media: JSX.IntrinsicAttributes & ICardProp) => {
              const isFavorite = isItemFavorite(media.id);
              return (
                <ListItem
                  className="mb-3"
                  key={media.id}
                  // to={articleLinkWithName(media.id, media.name)}
                >
                  <CardNew
                    {...media}
                    action={addToFavorite}
                    favoriteList={favoriteList}
                    isFavorite={isFavorite}
                    articleLink={getArticleLink(
                      media.id,
                      media.name,
                      media.slug
                    )}
                  />
                </ListItem>
              );
            })
          : null}
      </ul>
    </div>
  );
}
